import { MainContent } from './components/MainContent';
import { Header } from './components/Header';
import { GlobalStyle } from './styles/global';

export const App = () => {
  return (
    <>
      <Header />
      <MainContent />
      <GlobalStyle />
    </>
  )
}
